import request from '@/config/axios'

export const getUidApi = (params: any) => {
  return request.get({ url: '/upms-web/admin/user/search', params })
}

//根据uid查询用户
export const getUserByUidApi = (params: any) => {
  return request.get({ url: '/upms-web/admin/user/queryByUid', params })
}

export const getEmailApi = (params: any) => {
  return request.get({ url: '/upms-web/admin/user/email/search', params })
}

export const getMenuApi = () => {
  return request.get({ url: '/upms-web/admin/user/menu' })
}

export const getFileUploadSignApi = (key: string) => {
  return request.get({ url: `/device-admin/admin/cabinet/file/upload/getSign?key=${key}` })
}

// 发送指令
export const cabinetDeviceCommandApi = (data: any) => {
  return request.post({ url: `/device-admin/admin/cabinet/device/command`, data })
}

// 获取结果
export const cabinetDeviceCommandResultApi = (uuid) => {
  return request.get({
    url: `/device-admin/admin/cabinet/device/command/result`,
    params: { texNo: uuid }
  })
}

//V2版本
// 发送指令
export const cabinetDeviceCommandV2Api = (data: any) => {
  return request.post({ url: `/device-admin/admin/cabinet/device/command/v2`, data })
}

// 获取结果
export const cabinetDeviceCommandResultV2Api = (uuid) => {
  return request.get({
    url: `/device-admin/admin/cabinet/device/command/result/v2`,
    params: { txnNo: uuid }
  })
}

export const getExchangeModeApi = () => {
  return request.get({ url: '/upms-web/admin/tenant/current' })
}

// 搜索会员卡ID
export const searchMemberCardApi = (params: any): Promise<IResponse> => {
  return request.get({ 
    url: '/fantasy-battery-operation-web/admin/battery/memberCard/search', 
    params 
  })
}

// 搜索车辆VIN码
export const searchCarVinApi = (params: any): Promise<IResponse> => {
  return request.get({ 
    url: '/fantasy_car_device_web/admin/car/device/vin/search', 
    params 
  })
}

// 搜索电池IOT编号
export const searchBatteryIotApi = (params: any): Promise<IResponse> => {
  return request.get({ 
    url: '/fantasy-bms-web/admin/battery/iot/search', 
    params 
  })
}

// 搜索车辆IOT编号
export const searchCarIotApi = (params: any): Promise<IResponse> => {
  return request.get({ 
    url: '/fantasy_car_device_web/admin/car/device/iot/search', 
    params 
  })
}
